<p-panel>
  <app-reactive-form-builder
    #builderRef
    [form]="form.formFields"
    [id]="reactiveFormRecordId"
    [request]="request"
    [getRequest]="tratamientosApi.tratamientosManez.GET"
    [previousData]="initialPreviousData"
    (stableValueChanges)="stableValueChanges($event)"
    (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
    (goBack)="goBack()">
    <div slot="before-actions" class="col-12 mt-4">
      <div class="caudal-summary card border-0 shadow-sm">
        <div class="card-body p-3">
          <h5 class="card-title mb-3">Caudal por presión</h5>
          <div class="table-responsive">
            <table class="registro-table table table-sm table-bordered text-center mb-0">
              <tbody>
                <tr>
                  <td class="font-weight-bold text-nowrap">PRESIÓN (BAR)</td>
                  <td *ngFor="let i of pressureValues">
                    {{ i }}
                  </td>
                </tr>
                <tr class="font-weight-bold">
                  <td class="text-nowrap">Caudal (l/min)</td>
                  <td *ngFor="let i of pressureValues">
                    {{ totalCaudales[i] || 0 }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </app-reactive-form-builder>
</p-panel>
